import React from 'react';
import NooderaSwiper from 'components/NooderaSwiper';
import Skeleton from 'components/Skeleton';
import { CardItemWrapper, StyledCard } from '../LearnerHome.styles';
import { CELLPHONE_LARGE_WIDTH } from 'commons/constants';
import { SwiperSlide } from 'swiper/react';
import { useWidth } from 'utils/customHooks';
import { Course } from 'commons/types/courseTypes';

interface CourseCarouselProps {
  loading: boolean;
  courses?: Course[];
}

const renderCoursesSkeleton = () => (
  <SwiperSlide key='course-card-skeleton'>
    <CardItemWrapper>
      <Skeleton type='course-card' container={StyledCard} />
    </CardItemWrapper>
  </SwiperSlide>
);

const renderCourse = (course: Course) => (
  <SwiperSlide key={course.id}>
    <CardItemWrapper>
      <div>{course.title}</div>
    </CardItemWrapper>
  </SwiperSlide>
);

const CoursesCarousel: React.FC<CourseCarouselProps> = ({ loading, courses = [] }) => {
  const width = useWidth();
  return (
    <NooderaSwiper
      id='noodera-swiper-courses'
      showArrows={
        loading
          ? width > CELLPHONE_LARGE_WIDTH
          : courses.length > 0 && width > CELLPHONE_LARGE_WIDTH
      }
      spaceBetween={5}
      // @ts-ignore
      breakpoints={{
        '1199': { slidesPerView: 4 },
        '991': { slidesPerView: 3 },
        '768': { slidesPerView: 2 },
        '320': { slidesPerView: 1.1 },
      }}
    >
      {loading
        ? Array.from({ length: 4 }).map(() => renderCoursesSkeleton())
        : courses.map(renderCourse)}
    </NooderaSwiper>
  );
};

export default CoursesCarousel;
